import React from 'react';
import PropTypes from 'prop-types';
import jsonp from 'jsonp';

const getAjaxUrl = url => url.replace('/post?', '/post-json?');

class SubscribeForm extends React.Component {
  constructor(props, ...args) {
    super(props, ...args);
    this.state = {
      status: null,
      msg: null,
      isButtonDisable: true,
    };
  }
  validate = () => {
    if (
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
        this.input.value
      )
    ) {
      this.setState({
        isButtonDisable: false,
      });
    } else {
      if (!this.state.isButtonDisable) {
        this.setState({
          isButtonDisable: true,
        });
      }
    }
  };
  onSubmit = e => {
    e.preventDefault();
    if (!this.input.value || this.input.value.length < 5 || this.input.value.indexOf('@') === -1) {
      this.setState({
        status: 'error',
      });
      return;
    }
    const url = getAjaxUrl(this.props.action) + `&EMAIL=${encodeURIComponent(this.input.value)}`;
    this.setState(
      {
        status: 'sending',
        msg: null,
      },
      () =>
        jsonp(
          url,
          {
            param: 'c',
          },
          (err, data) => {
            if (err) {
              this.setState({
                status: 'error',
                msg: err,
              });
            } else if (data.result !== 'success') {
              this.setState({
                status: 'error',
                msg: data.msg,
              });
            } else {
              this.setState({
                status: 'success',
                msg: data.msg,
              });
            }
          }
        )
    );
  };
  render() {
    const { action, messages, className, style, styles } = this.props;
    const { status, msg } = this.state;
    return (
      <div className={className} style={style}>
        <form action={action} method="post">
          <div className="subscription-container">
            <input
              ref={node => (this.input = node)}
              type="email"
              defaultValue=""
              name="EMAIL"
              required={true}
              placeholder={messages.inputPlaceholder}
              className="subscription-input"
              onChange={this.validate}
            />
            <button
              className={
                this.state.status === 'sending' ||
                this.state.status === 'success' ||
                this.state.isButtonDisable
                  ? 'subscription-button-disable'
                  : 'subscription-button'
              }
              disabled={
                this.state.status === 'sending' ||
                this.state.status === 'success' ||
                this.state.isButtonDisable
              }
              onClick={this.onSubmit}
              type="submit"
            >
              {messages.btnLabel}
            </button>
          </div>
          {status === 'sending' && (
            <p style={styles.sending} dangerouslySetInnerHTML={{ __html: messages.sending }} />
          )}
          {status === 'success' && (
            <p
              style={styles.success}
              dangerouslySetInnerHTML={{ __html: messages.success || msg }}
            />
          )}
          {status === 'error' && (
            <p style={styles.error} dangerouslySetInnerHTML={{ __html: messages.error || msg }} />
          )}
        </form>
      </div>
    );
  }
}

SubscribeForm.propTypes = {
  messages: PropTypes.object,
  styles: PropTypes.object,
};

SubscribeForm.defaultProps = {
  messages: {
    inputPlaceholder: 'Votre email',
    btnLabel: 'Envoyer',
    sending: 'Envoi en cours...',
    success:
      "Merci de votre intérêt!<p>Nous devons confirmer votre adresse e-mail. Pour compléter le processus d'abonnement, veuillez cliquer sur le lien contenu dans l'e-mail que nous venons de vous envoyer.</p>",
    error: "Oops, impossible d'enregistrer cette adresse",
  },
  styles: {
    sending: {
      fontSize: 18,
      color: 'auto',
    },
    success: {
      fontSize: 18,
      color: 'green',
    },
    error: {
      fontSize: 18,
      color: 'red',
    },
  },
};

export default SubscribeForm;



// WEBPACK FOOTER //
// ./src/templates/SubscribeForm.js